import { render, staticRenderFns } from "./LocalSearches.vue?vue&type=template&id=79a4cd66"
import script from "./LocalSearches.vue?vue&type=script&lang=js"
export * from "./LocalSearches.vue?vue&type=script&lang=js"
import style0 from "./LocalSearches.vue?vue&type=style&index=0&id=79a4cd66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports